export var Backtracking;
(function (Backtracking) {
    Backtracking[Backtracking["None"] = 0] = "None";
    Backtracking[Backtracking["Full"] = 1] = "Full";
    Backtracking[Backtracking["Linear"] = 2] = "Linear";
    Backtracking[Backtracking["Exponential"] = 3] = "Exponential";
    //Grid,
    //Combination
})(Backtracking || (Backtracking = {}));
